module.exports = __webpack_public_path__ + "img/shopIcon6.d0670f4e.png";